import { useState } from "react";

export default function AchievementForm({ onSubmit, achievement, teamId }: { onSubmit: (data: any) => void, achievement?: any, teamId: number }) {

    const isNew = achievement === null || achievement === undefined;

    const [form, setForm] = useState({
        name: achievement?.name ?? "",
        place: achievement?.place ?? "",
        date: achievement?.date ?? "",
        lineup: achievement?.lineup ?? "",
        teamId: teamId,
    });

    function updateField(key, value) {
        setForm(prev => ({ ...prev, [key]: value }));
    }

    function handleSubmit(e) {
        e.preventDefault();
        onSubmit(form);
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-6 max-w-xl mx-auto p-6 bg-white rounded-xl shadow">

            <h2 className="text-2xl font-semibold mb-4">{isNew ? "Create Achievement" : "Edit Achievement"}</h2>

            <div>
                <label className="block text-sm font-medium mb-1">Name</label>
                <input
                    type="text"
                    defaultValue={form.name}
                    onChange={(e) => updateField("name", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg
                               focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
            </div>
            <div>
                <label className="block text-sm font-medium mb-1">Place</label>
                <input
                    type="text"
                    defaultValue={form.place}
                    onChange={(e) => updateField("place", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg
                               focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
            </div>
            <div>
                <label className="block text-sm font-medium mb-1">Date</label>
                <input
                    type="date"
                    defaultValue={form.date}
                    onChange={(e) => updateField("date", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg
                               focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
            </div>
            <div>
                <label className="block text-sm font-medium mb-1">Lineup</label>
                <input
                    type="text"
                    defaultValue={form.lineup}
                    onChange={(e) => updateField("lineup", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg
                               focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
            </div>

            {/* SAVE BUTTON */}
            <button
                type="submit"
                className="w-full py-2 px-4 bg-indigo-600 text-white rounded-lg
                           hover:bg-indigo-700 transition font-medium"
            >
                {isNew ? "Create Achievement" : "Save Changes"}
            </button>
        </form>
    );
}